var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgRedEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#F70303"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4522_31146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33 16.5H15C14.8011 16.5 14.6103 16.579 14.4697 16.7197C14.329 16.8603 14.25 17.0511 14.25 17.25V30C14.25 30.3978 14.408 30.7794 14.6893 31.0607C14.9706 31.342 15.3522 31.5 15.75 31.5H32.25C32.6478 31.5 33.0294 31.342 33.3107 31.0607C33.592 30.7794 33.75 30.3978 33.75 30V17.25C33.75 17.0511 33.671 16.8603 33.5303 16.7197C33.3897 16.579 33.1989 16.5 33 16.5ZM32.25 30H15.75V18.9553L23.4928 26.0531C23.6312 26.1801 23.8122 26.2506 24 26.2506C24.1878 26.2506 24.3688 26.1801 24.5072 26.0531L32.25 18.9553V30Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4522_31146"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgRedEmail);
export default __webpack_public_path__ + "static/media/BgRedEmail.d34ce9f942ea1d4fc20b3be8fbe0269f.svg";
export { ForwardRef as ReactComponent };